import "./notification.scss";
import { useNotification } from "./hooks/useNotification";
import NotificationIcon from "./components/NotificationIcon";
import NotificationList from "./components/NotificationList";

const Notification = ({ isNotificationOpen, setNotificationOpen, closeUserDropdown }) => {
    const { 
        notifications, 
        loading, 
        error, 
        unreadCount, 
        handleToggle, 
        handleItemClick,
        handleAcceptFriend,
        handleRejectFriend 
    } = useNotification(isNotificationOpen, setNotificationOpen, closeUserDropdown);

    return (
        <div className="notification">
            <NotificationIcon 
                count={unreadCount} 
                onClick={handleToggle} 
            />

            {isNotificationOpen && (
                <NotificationList 
                    notifications={notifications}
                    loading={loading}
                    error={error}
                    onItemClick={handleItemClick}
                    onAcceptFriend={handleAcceptFriend}
                    onRejectFriend={handleRejectFriend}
                />
            )}
        </div>
    );
};

export default Notification;